export class AlertSettings {

    zoneCode: string;
    emails: string[];
    devices: string[];
}